import { render, staticRenderFns } from "./detePamseManger.vue?vue&type=template&id=2b6f7509&"
import script from "./detePamseManger.vue?vue&type=script&lang=js&"
export * from "./detePamseManger.vue?vue&type=script&lang=js&"
import style0 from "./detePamseManger.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b6f7509')) {
      api.createRecord('2b6f7509', component.options)
    } else {
      api.reload('2b6f7509', component.options)
    }
    module.hot.accept("./detePamseManger.vue?vue&type=template&id=2b6f7509&", function () {
      api.rerender('2b6f7509', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/detePamseManger.vue"
export default component.exports